<script setup lang="ts">
import About from "@/views/playground/player/partner/planner/About.vue";
</script>
<template>
  <about></about>
</template>
<style scoped></style>
